module.exports = __webpack_public_path__ + "img/hu_no.75852384.png";